module.exports = __webpack_public_path__ + "img/br.fc8cf29f.jpg";